import { headers } from 'services/auth'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const GET_AMENITIES = `${API_URL}/resources/amenities`

export const getAmenities = () => {
  return axios.get(`${GET_AMENITIES}`, { headers: headers() })
}
